// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__uLaSa","addBtnContainer":"AddDetails_addBtnContainer__t+yoM"};